// extracted by mini-css-extract-plugin
export var horizontalrule = "HorizontalRule-module--horizontalrule--3ead6";